// extracted by mini-css-extract-plugin
export default {"root":"MainBoxLayout_root__fkr4t","body":"MainBoxLayout_body__AnYu6","clickable":"MainBoxLayout_clickable__mvkvs","container":"MainBoxLayout_container__mDHNI"};